import React from 'react';

const TransactionsList = ({ transactions, isLoading, filters, onFilterChange, onApply, onReset, categories, accounts }) => {
    const { startDate, endDate, textFilter, categoryFilter, frequencyFilter, accountFilter } = filters;

    const getAccountName = (accountId) => {
        const account = accounts.find(acc => acc.id === accountId);
        return account ? account.name : 'Unknown Account';
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-semibold">Transactions</h2>
            </div>
            <div className="bg-gray-50 p-4 rounded-md mb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
                <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700">Start Date</label>
                    <input type="date" value={startDate} onChange={e => onFilterChange('startDate', e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md"/>
                </div>
                <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700">End Date</label>
                    <input type="date" value={endDate} onChange={e => onFilterChange('endDate', e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md"/>
                </div>
                <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700">Description/Vendor</label>
                    <input type="text" value={textFilter} onChange={e => onFilterChange('textFilter', e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md"/>
                </div>
                <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700">Account</label>
                    <select value={accountFilter} onChange={e => onFilterChange('accountFilter', e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md">
                        <option value="">All Accounts</option>
                        <option value="all_debit">All Debit Accounts</option>
                        <option value="all_credit">All Credit Accounts</option>
                        {accounts.map(acc => <option key={acc.id} value={acc.id}>{acc.name}</option>)}
                    </select>
                </div>
                <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700">Category</label>
                    <select value={categoryFilter} onChange={e => onFilterChange('categoryFilter', e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md">
                        <option value="">All</option>
                        {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                    </select>
                </div>
                <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700">Frequency</label>
                    <select value={frequencyFilter} onChange={e => onFilterChange('frequencyFilter', e.target.value)} className="mt-1 w-full px-3 py-2 border rounded-md">
                        <option value="">All</option>
                        <option>Once</option>
                        <option>Weekly</option>
                        <option>Fortnightly</option>
                        <option>Monthly</option>
                        <option>Quarterly</option>
                        <option>Yearly</option>
                    </select>
                </div>
                <div className="flex gap-2 sm:col-span-full justify-end">
                    <button onClick={onApply} className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded-md">Apply</button>
                    <button onClick={onReset} className="w-full sm:w-auto px-4 py-2 bg-gray-200 rounded-md">Reset</button>
                </div>
            </div>
            {isLoading ? <p>Loading transactions...</p> : (
                <ul className="divide-y divide-gray-200">
                    {transactions.map(tx => (
                        <li key={tx.id} className="py-3 flex justify-between items-center">
                            <div>
                                <p className="font-medium">{tx.description} <span className="text-gray-500 text-sm">{tx.vendor}</span></p>
                                <p className="text-sm text-gray-500">{new Date(tx.date).toLocaleDateString()} - {tx.category} ({getAccountName(tx.accountId)})</p>
                            </div>
                            <p className={`font-semibold ${tx.amount > 0 ? 'text-green-600' : 'text-red-600'}`}>
                                {tx.amount > 0 ? '+' : ''}${Math.abs(tx.amount).toFixed(2)}
                            </p>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default TransactionsList;